import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainContentLayout from "./components/layouts/MainContentLayout";
import Loader from "./components/utilities/Loader";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import HomeContentLayout from "./components/layouts/HomeContentLayout";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const Home = lazy(() => import("./pages/Home"));
const AccountSummary = lazy(() => import("./pages/AccountSummary"));
const Heroes = lazy(() => import("./pages/Heroes"));
const Items = lazy(() => import("./pages/Items"));
const HeroStats = lazy(() => import("./pages/HeroStats"));

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Suspense fallback={<Loader message={"Loading Application Data"} />}>
          <Routes>
            <Route element={<HomeContentLayout />}>
              <Route exact path="/" element={<Home />} />
            </Route>
            <Route path="/accountsummary" element={<AccountSummary />} />
            <Route path="/heroes" element={<MainContentLayout />}>
              <Route path="all" element={<Heroes />} />
              <Route path=":heroName" element={<HeroStats />} />
            </Route>
            <Route path="/items" element={<MainContentLayout />}>
              <Route path="all" element={<Items />} />
            </Route>
          </Routes>
        </Suspense>
      </Router>
      {/* <ReactQueryDevtools initialIsOpen={false} position="bottom-right" /> */}
    </QueryClientProvider>
  );
};

export default App;
